import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { usePayroll, shiftMonth, monthLabel } from "@/hooks/usePayroll";
import { PayrollStats, PayrollTable } from "@/components/app/PayrollParts";

export default function Payroll() {
  const { month, setMonth, data, busy, pay, unpay } = usePayroll();
  const [expanded, setExpanded] = useState(null);
  const toggle = (id) => setExpanded(expanded === id ? null : id);

  return (
    <div className="space-y-6" data-testid="payroll-page">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="icon" onClick={() => setMonth(shiftMonth(month, -1))} data-testid="payroll-prev-month"><ChevronLeft className="h-4 w-4" /></Button>
        <div className="text-lg font-bold text-slate-900 min-w-[160px] text-center" style={{ fontFamily: "Outfit" }} data-testid="payroll-month-label">{monthLabel(month)}</div>
        <Button variant="outline" size="icon" onClick={() => setMonth(shiftMonth(month, 1))} data-testid="payroll-next-month"><ChevronRight className="h-4 w-4" /></Button>
        <Button variant="ghost" size="sm" onClick={() => setMonth(shiftMonth(new Date(), 0))} data-testid="payroll-this-month">Bu Ay</Button>
      </div>
      <PayrollStats data={data} />
      <PayrollTable rows={data?.rows} expanded={expanded} onToggle={toggle} onPay={pay} onUnpay={unpay} busy={busy} />
    </div>
  );
}
